import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DataLoaderComponent } from './data-loader/data-loader.component';
import { HorizontalCalendarComponent } from './horizontal-calendar/horizontal-calendar.component';
import { DateStripPickerComponent } from './date-strip-picker/date-strip-picker.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeBarComponent } from './time-bar/time-bar.component';
import { PermissionTimeColonDirective } from './permission-time-colon.directive';
import { TimeInputComponent } from './time-input/time-input.component';
import { MatTimepickerModule } from 'mat-timepicker';
import { ClassificationDistributionComponent } from './classification-distribution/classification-distribution.component';
import { PlaceHolderComponent } from './place-holder/place-holder.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { LeaveNoticeDialogComponent } from './leave-notice-dialog/leave-notice-dialog.component';
import { CalanderMonthPickerHeaderComponent } from './calander-month-picker-header/calander-month-picker-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DataTableComponent } from './data-table/data-table.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { SearchDataTableComponent } from './search-data-table/search-data-table.component';
import { WeekDayPickerComponent } from './week-day-picker/week-day-picker.component';
import { TimeBarV2Component } from './time-bar-v2/time-bar-v2.component';
import { NewDataLoaderComponent } from './new-data-loader/new-data-loader.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { CommingSoonComponent } from './comming-soon/comming-soon.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { TimeBarV3Component } from './time-bar-v3/time-bar-v3.component';
import { CurrentStatusComponent } from './current-status/current-status.component';
import { ReportPeriodSelectorComponent } from './report-period-selector/report-period-selector.component';
import { DateRangeFieldComponent } from './report-period-selector/date-range-field.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { SiteManagerHierarchyComponent } from './site-manager-hierarchy/site-manager-hierarchy.component';
import { MatSelectModule } from '@angular/material/select';
import { TeamAccessConfirmationDialogComponent } from './team-access-confirmation-dialog/team-access-confirmation-dialog.component';
import { EmployeeStatusStatsComponent } from './employee-status-stats/employee-status-stats.component';
import { TelInputComponent } from './tel-input/tel-input.component';
import { BiometricPushDialogComponent } from './biometric-push-dialog/biometric-push-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
// Declared here, not in ViewsModule: the punches panel and its dialog are opened
// from Employee Work Status (ViewsModule) AND the Biometric OT report
// (BiometricDevicesModule), and a component may only be declared once. Both of
// those modules already import SharedModule.
import { BiometricDetailsDialogComponent } from '../views/reports-pages/attendance-report/biometric-details-dialog/biometric-details-dialog.component';
import { BiometricPunchesComponent } from '../views/reports-pages/attendance-report/biometric-punches/biometric-punches.component';
import { WorkActivityComponent } from '../views/reports-pages/attendance-report/work-activity/work-activity.component';
// Declared here, not in ViewsModule: the Work Activity table (a SharedModule component) shows the cell in the
// Employee Work Status popup, and a component can only use elements its own module declares or imports.
import { StartLocationCellComponent } from '../views/reports-pages/start-location/start-location-cell.component';
import { StartLocationMapDialogComponent } from '../views/reports-pages/start-location/start-location-map-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OvertimeRuleDetailComponent } from './overtime-day/overtime-rule-detail.component';
import { OvertimeDayWindowComponent } from './overtime-day/overtime-day-window.component';
import { OvertimeDayExtrasComponent } from './overtime-day/overtime-day-extras.component';
import { OvertimeDayMessageComponent } from './overtime-day/overtime-day-message.component';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}


@NgModule({
  declarations: [
    PermissionTimeColonDirective,
    TimeInputComponent,
    BiometricDetailsDialogComponent,
    BiometricPunchesComponent,
    WorkActivityComponent,
    StartLocationCellComponent,
    StartLocationMapDialogComponent,
    DataLoaderComponent,
    HorizontalCalendarComponent,
    TimeBarComponent,
    ClassificationDistributionComponent,
    PlaceHolderComponent,
    ConfirmationDialogComponent,
    LeaveNoticeDialogComponent,
    CalanderMonthPickerHeaderComponent,
    DataTableComponent,
    SearchDataTableComponent,
    WeekDayPickerComponent,
    TimeBarV2Component,
    NewDataLoaderComponent,
    PieChartComponent,
    CommingSoonComponent,
    BarChartComponent,
    TimeBarV3Component,
    CurrentStatusComponent,
    ReportPeriodSelectorComponent,
    DateRangeFieldComponent,
    MultiSelectComponent,
    SiteManagerHierarchyComponent,
    TeamAccessConfirmationDialogComponent,
    EmployeeStatusStatsComponent,
    TelInputComponent,
    BiometricPushDialogComponent,
    DateStripPickerComponent,
    OvertimeRuleDetailComponent,
    OvertimeDayWindowComponent,
    OvertimeDayExtrasComponent,
    OvertimeDayMessageComponent
  ],
  imports: [
    CommonModule,
    OverlayModule,
    MatTimepickerModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSliderModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    FormsModule,
    TranslateModule,
    AlertModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatIconModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatChipsModule,
    MatSelectModule,
    MatDialogModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  exports: [
    PermissionTimeColonDirective,
    TimeInputComponent,
    BiometricDetailsDialogComponent,
    BiometricPunchesComponent,
    WorkActivityComponent,
    StartLocationCellComponent,
    StartLocationMapDialogComponent,
    MatDialogModule,
    DataLoaderComponent,
    HorizontalCalendarComponent,
    TimeBarComponent,
    TimeBarV2Component,
    ClassificationDistributionComponent,
    PlaceHolderComponent,
    ConfirmationDialogComponent,
    LeaveNoticeDialogComponent,
    DataTableComponent,
    SearchDataTableComponent,
    WeekDayPickerComponent,
    NewDataLoaderComponent,
    PieChartComponent,
    CommingSoonComponent,
    BarChartComponent,
    TimeBarV3Component,
    CurrentStatusComponent,
    ReportPeriodSelectorComponent,
    DateRangeFieldComponent,
    MatTooltipModule,
    MatIconModule,
    MultiSelectComponent,
    SiteManagerHierarchyComponent,
    EmployeeStatusStatsComponent,
    TelInputComponent,
    BiometricPushDialogComponent,
    DateStripPickerComponent,
    OvertimeRuleDetailComponent,
    OvertimeDayWindowComponent,
    OvertimeDayExtrasComponent,
    OvertimeDayMessageComponent
  ],
  entryComponents: [
    CalanderMonthPickerHeaderComponent,
    BiometricPushDialogComponent,
    BiometricDetailsDialogComponent
  ]
})
export class SharedModule { }
